import { EMPTY_STRING, LEARN_MORE_URL } from "../../AppConstants";
import { TranscriptionAlertActions, TranscriptionAlertButtonType, TranscriptionAlertState } from "../../frontend/components/Popups/TranscriptionAlert";
import dispatcher from "../../frontend/dispatcher";
import { isEmptyString, isNullOrUndefined } from "../../utils/utils";
import { HostAppSettingName, HostAppSettings } from "../office-js/HostAppSettings";

export const IsWordDocumentIdentityEmpty = () => {
  return isEmptyString(HostAppSettings.GetSettingAsString(HostAppSettingName.WordDocumentIdentityEmail));
}

export const ShouldShowWordIdentitySwitchDialog = (primaryIdentityEmail: string | undefined) => {
  const shouldShowWordIdentitySwitchDialog = !IsWordDocumentIdentityEmpty()
    && (primaryIdentityEmail != HostAppSettings.GetSettingAsString(HostAppSettingName.WordDocumentIdentityEmail));
  return shouldShowWordIdentitySwitchDialog;
}

export const ShowWordIdentitySwitchDialog = (primaryIdentityEmail: string | undefined) => {

  const associatedDocumentName = GetWordDocumentName();
  const activeIdentityEmail = isNullOrUndefined(primaryIdentityEmail) ? EMPTY_STRING : primaryIdentityEmail;
  const documentIdentityEmail = isNullOrUndefined(HostAppSettings.GetSettingAsString(HostAppSettingName.WordDocumentIdentityEmail))
    ? EMPTY_STRING : HostAppSettings.GetSettingAsString(HostAppSettingName.WordDocumentIdentityEmail);

  let identitySwitchDialogInfoString = TranscriptionStrings.WordAccountSwitchDialogBodyInfoText;
  identitySwitchDialogInfoString = identitySwitchDialogInfoString.replace('{0}', '[' + activeIdentityEmail + ']');
  identitySwitchDialogInfoString = identitySwitchDialogInfoString.replace('{1}', '\'' + associatedDocumentName
    + '\'');
  identitySwitchDialogInfoString = identitySwitchDialogInfoString.replace('{2}', '[' + documentIdentityEmail + ']');

  const transcriptionAlertState: TranscriptionAlertState = {
    title: TranscriptionStrings.WordAccountSwitchDialogHeaderText,
    information: identitySwitchDialogInfoString + '\n\n' + TranscriptionStrings.AccountSwitchDialogBodyRelaunchText,
    buttonInfo: { buttonType: TranscriptionAlertButtonType.LINK, linkText: TranscriptionStrings.TranscriptionPaneLearnLabel, hyperLink: LEARN_MORE_URL }
  }

  dispatcher.dispatch({
    type: TranscriptionAlertActions.ShowTranscriptionAlert,
    payload: transcriptionAlertState
  });
}

export const GetWordDocumentName = () => {
  // fileUrl will be the complete OneDrive URL for file
  let fileUrl = Office.context.document.url;
  // Getting the filename only with extension like 'Document1.docx'
  let docNameWithExtension = fileUrl.replace(/^.*[\\\/]/, '');

  // Extra check where in case doc name doesn't contain .docx extension, we will simple return doc name
  if (docNameWithExtension.indexOf('.docx') >= 0) {
    // Trimming the extension '.docx' from filename with extension
    return docNameWithExtension.slice(0, -5);
  }
  return docNameWithExtension;
}